import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { extractContentFromPlainTextSections } from 'copilot-plugins/plugins/workflowsGenerateActionsPlugin/utils/extractSectionsData';
import { isMessageWithSections } from 'copilot-plugins/plugins/workflowsGenerateActionsPlugin/utils/messageUtils';
import { extractActionButtons } from 'copilot-plugins/plugins/workflowsGenerateActionsPlugin/utils/extractActionButtons';
import PreviewButton from 'copilot-plugins/plugins/workflowsGenerateActionsPlugin/components/PreviewButton';
import ApplyButton from 'copilot-plugins/plugins/workflowsGenerateActionsPlugin/components/ApplyButton';
import RegenerateButton from 'copilot-plugins/plugins/workflowsGenerateActionsPlugin/components/RegenerateButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const WorkflowsGenerateActionsPlugin = {
  gate: 'Copilot:Collaborate',
  // Will need a workflow specific gate. Caution the gate caused the intent to not show up last time.
  intentTypes: ['generate_automation_actions'],
  collaborateCopilotMessageTypes: [],
  sectionRenderer: message => {
    if (!isMessageWithSections(message)) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "copilotPlugins.workflowsGenerateActionsPlugin.noParsedData"
      });
    }
    const contentTextArray = extractContentFromPlainTextSections(message);
    if (!(contentTextArray !== null && contentTextArray !== void 0 && contentTextArray.length)) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "copilotPlugins.workflowsGenerateActionsPlugin.noParsedData"
      });
    }
    return /*#__PURE__*/_jsx(_Fragment, {
      children: contentTextArray.map(contentText => /*#__PURE__*/_jsx(Text, {
        as: "p",
        typography: "body-100",
        marginBlockEnd: "200",
        children: contentText
      }, contentText))
    });
  },
  actionsRenderer: ({
    // state,
    message,
    actionFn,
    // ChatSpotButtons,
    ChatSpotStyledButtonComponent,
    usageTracker
  }) => {
    if (!isMessageWithSections(message)) {
      return null;
    }
    const allActionButtons = extractActionButtons(message);
    if (!allActionButtons) {
      return null;
    }
    const {
      previewButton,
      applyButton,
      regenerateButton
    } = allActionButtons;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [previewButton && /*#__PURE__*/_jsx(PreviewButton, {
        actionFn: actionFn,
        actionButtonObj: allActionButtons.previewButton,
        streamingState: message === null || message === void 0 ? void 0 : message.streamingState,
        messageQuery: message === null || message === void 0 ? void 0 : message.query
      }), applyButton && /*#__PURE__*/_jsx(ApplyButton, {
        actionFn: actionFn,
        actionButtonObj: applyButton,
        ChatSpotStyledButtonComponent: ChatSpotStyledButtonComponent,
        usageTracker: usageTracker,
        messageQuery: message === null || message === void 0 ? void 0 : message.query
      }), regenerateButton && /*#__PURE__*/_jsx(RegenerateButton, {
        actionButtonObj: regenerateButton,
        streamingState: message === null || message === void 0 ? void 0 : message.streamingState,
        messageQuery: message === null || message === void 0 ? void 0 : message.query
      })]
    });
  }
};